import "bootstrap/dist/css/bootstrap.min.css";
import '@mdxeditor/editor/style.css'
import "./globals.css";
import "./extra.css";
import { ClientProviders } from "./providers";
import { Outlet } from "react-router";

export default function RootLayout({ children }: { children?: React.ReactNode }) {
    return (
        <ClientProviders>
            {children ? children : <Outlet />}
        </ClientProviders>
    );
}